import React from 'react';
import {
  POINTS_ROUTE,
  BENEFITS_ROUTE,
  EXCHANGE_ROUTE,
} from '../../../../constants/Routes';
import PointsIcon from '../../../common/icons/PointsIcon';
import BenefitsIcon from '../../../common/icons/BenefitsIcon';
import ExchageIcon from '../../../common/icons/ExchangeIcon';

export const pointsGroup = [
  {
    route: POINTS_ROUTE,
    icon: <PointsIcon size="30px" />,
    title: 'Ripley Puntos Go',
    id: 'makeExchangesSection',
  },
  {
    route: BENEFITS_ROUTE,
    icon: <BenefitsIcon size="30px" />,
    title: 'Beneficios',
    id: 'lookBenefitsSection',
  },
  {
    route: EXCHANGE_ROUTE,
    icon: <ExchageIcon size="30px" />,
    title: 'Mis canjes realizados',
    id: 'lookExchangesSection',
  },
];
